// import { MenuHeader, MenuIcon, Menuoptions } from "@/constancs/cssconst";
import React, { useState } from "react";
import { useStore } from "../StateProvider";
import { FaChevronRight, FaChevronDown } from "react-icons/fa";
import "./sider.css";

// import { useStore } from "../StateProvider";

const Sider = ({ menus, setsider }) => {
  const store = useStore();
  // the menu has some indicators to classify
  // every object has major components like
  //   1. "meta-data" - has the basic infor like icon location and this object is parent or not as Boolean
  //   2. child - which has the info like what are the child the going to have
  //   3. link - which create the object as a link button so we can easy to navigate to the link
  //   4. button - which help to perform any function which the store has

  const [sidemenu, setsidemenu] = useState(menus);

  function open(menu, open) {
    // setsidemenu(!sidemenu);

    menu = menu.replace("`", "");
    let position = "";
    menu.split("`").map((item) => (position += "['" + item + "'].child"));
    position = position.substring(0, position.length - 6);

    position =
      "sidemenu" +
      position +
      "['meta-data'].open = !sidemenu" +
      position +
      "['meta-data'].open";

    eval(position);
    // console.log("menus", sidemenu);
    setsidemenu((prev) => {
      prev = sidemenu;
      return { ...prev };
    });
  }

  return (
    <div className="flex flex-col gap-1 pl-[5%] py-[8%]">
      <Menus obj={sidemenu} open={open} parent={""} setsider={setsider} />
    </div>
  );
};

function Menus({ obj, parent, open, setsider }) {
  return Object.keys(obj).map((head, index) => {
    // console.log("new log", obj[head], obj[head]["meta-data"].icon);
    if (!obj[head].disabled) {
      return (
        <Menu
          key={index}
          heading={head}
          icon={obj[head]["meta-data"].icon}
          parent={obj[head]["meta-data"].parent}
          onClick={() => {
            open(parent + "`" + head, obj[head]["meta-data"].open);
          }}
          open={obj[head]["meta-data"].open}
          link={obj[head].link}
          button={obj[head].button}
          setsider={setsider}
        >
          {" "}
          {obj[head].child && (
            <Menus
              obj={obj[head].child}
              open={open}
              parent={parent + "`" + head}
              setsider={setsider}
            />
          )}
        </Menu>
      );
    }
  });
}

function Menu({
  heading,
  icon,
  parent,
  children,
  onClick,
  open,
  link,
  button,
  setsider,
}) {
  const store = useStore();
  return (
    <>
      <div
        className={
          parent
            ? "flex items-center justify-start mb-[2%] gap-2 cursor-pointer "
            : "flex items-center justify-start my-[5%] gap-2 cursor-pointer"
        }
        onClick={(e) => {
          e.preventDefault();
          if (!link && !button) {
            onClick();
          }
          if (link && !button) {
            // store.reset({});
            store.navTo(link);
            setsider("max-sm:hidden");
          }
          if (button !== undefined && link === undefined) {
            switch (button.toLowerCase()) {
              case "logout":
                store.logout();
                setsider("max-sm:hidden");
                break;

              default:
                break;
            }
          }
        }}
      >
        <div className="text-[20px]">{icon}</div>
        <div className="flex items-center gap-3">
          <h1
            className={
              parent
                ? "max-sm:text-[30px] md:text-[14px] lg:text-[15px] "
                : "max-sm:text-[26px] md:text-[9px] lg:text-[12px] "
            }
          >
            {heading}
          </h1>
          {!link && !button && (open ? <FaChevronDown /> : <FaChevronRight />)}
        </div>
      </div>
      {parent && <hr className="w-[60%]" />}
      <div className=" md:ml-[12PX] lg:ml-[15PX] border-l-[1px] pl-2 border-secondary">
        {open && children}
      </div>
    </>
  );
}

export default Sider;
